<!-- TODO: Check isRemoved with the team if it can be substituted with permissions -->
@if (
  !isRemoved() &&
  (permDir.uipermission() !== PERMISSIONS.NONE || permDir.editPermissions())
) {
  <!-- Section Header -->
  @if (!settings().headerIsHidden) {
    <div
      uisectionheader
      [class.collabsible]="settings().isCollapsible"
      [class]="headerCssClass()"
      [attr.uisectionheader]="settings().isMinimized ? 'collapsed' : 'expanded'"
      (click)="toggle()"
    >
      @if (settings().collapsePosition === 'left' && settings().isCollapsible) {
        <ng-container #uiToolsDefaultRef>
          <icon
            uitool
            [iconSize]="'normal'"
            [iconDefinition]="
              settings().isMinimized ? ICONS.CHEVRON_DOWN : ICONS.CHEVRON_UP
            "
            class="labelInfo copy"
            (click)="toggle()"
          ></icon>
        </ng-container>
      }

      @if (!settings().titleIsHidden) {
        <span
          uisectiontitle
          [class]="titleCssClass()"
          [UiCopy]="settings().label!"
        >
          {{ settings().label }}
        </span>
        <ng-content select="[uiicon]"></ng-content>
        <span uispacer></span>
      }

      <!-- Section Tools -->
      <div uitoolstrip (click)="$event.stopPropagation()">
        <ng-content #uiToolsMarkupRef select="[uisectiontool]"></ng-content>
        <ng-template #uiToolsCodeRef></ng-template>
        @if (
          settings().collapsePosition === 'right' && settings().isCollapsible
        ) {
          <ng-container #uiToolsDefaultRef>
            <icon
              uisectiontool
              [iconDefinition]="
                settings().isMinimized ? ICONS.CHEVRON_DOWN : ICONS.CHEVRON_UP
              "
              (click)="toggle()"
            ></icon>
          </ng-container>
        }
        <!-- Option Remove Component -->
        @if (settings().isRemovable) {
          <icon
            uisectiontool
            [iconDefinition]="ICONS.CLOSE_SMALL"
            (click)="close($event)"
          ></icon>
        }
      </div>
    </div>
  }

  <!-- Section Content -->
  @if (!settings().isMinimized) {
    @if (contentDir.uicontentcomponent()) {
      <ng-template
        *ngComponentOutlet="
          contentDir.uicontentcomponent();
          inputs: contentDir.uicontentinput()
        "
      ></ng-template>
    } @else if (settings().useRouterOutlet) {
      <router-outlet class="hidden"></router-outlet>
    } @else if (settings().useNgContent) {
      <ng-content select="div[uisectioncontent]"></ng-content>
    } @else {
      <div
        uisectioncontent
        [class]="contentCssClass()"
        [uiloading]="loadingDir.uiloading()"
      >
        <ng-content></ng-content>

        @if (settings().noContentMsg) {
          <div UiSectionEmpty>
            {{ settings().noContentMsg }}
          </div>
        }
      </div>
    }
  }
}
